import "./FooterStyles.css";

const Footer = () =>{
    return(
        <div className="footer">
            
            <div className="top">
                <div className="top-left">
                    <h1>CAR-Ma</h1>
                    <h4>iGEM 2023</h4>
                    <p>The University of Hong Kong</p>
                </div>
        
                <div className="top-right">
                    <h3>Find us here!</h3>
                    <a href="https://www.instagram.com/hku.igem/">
                        <i className="fa-brands fa-instagram-square"/>
                    </a>
                    <img src="https://static.igem.wiki/teams/4696/wiki/footer-igem-hku2023-team-logo-white.png" className="footer-team-logo" alt="Our logo :)"></img>
                    <a href="https://twitter.com/HKU_iGEM">
                        <i className="fa-brands fa-twitter-square"/>
                    </a>
                    <p>Email: igemhku@hku.com</p>
                </div>
            </div>

            <div className="bottom">
                <h1 style={{textAlign: "center"}}>Our Sponsors</h1>
                <img src="https://static.igem.wiki/teams/4696/wiki/footer-sponsors-cropped.png" className="footer-sponsors-cropped" alt="our sponsors"></img>
            </div>

            <div className="license-and-repo">
                <br/>
                © 2023 - Content on this site is licensed under a <a class="subfoot" href="https://creativecommons.org/licenses/by/4.0/" rel="license">Creative Commons Attribution 4.0 International license</a>.
                <br/>
                The repository used to create this website is available at <a href="https://gitlab.igem.org/2023/hku-hongkong">gitlab.igem.org/2023/hku-hongkong</a>.
            </div>

        </div>
    )
}

export default Footer